<button
  df-button
  dfButtonType="primary"
  [dgxPopoverTrigger]="addExperiencePopover"
  class="add-content-button"
  data-dgat="add-experience-menu-8da"
  [attr.aria-label]="i18n.Core_AddExperience"
>
  <div class="l_flexbar gap-full-half">
    <df-icon icon="plus"></df-icon>
    <div>{{ i18n.Core_Add }}</div>
  </div>
</button>

<dgx-popover
  #addExperiencePopover
  [isOpen]="isAddExperiencePopoverOpen"
  (isOpenChange)="addExperiencePopoverToggled($event)"
  [popoverArrowHidden]="true"
  [appendToBody]="true"
  placement="bottom-right"
>
  <ul class="guts-p-full-1">
    <li
      *ngFor="let experienceType of experienceTypes; let last = last"
      data-dgat="add-experience-menu-d8e"
    >
      <button
        df-button
        dfButtonType="clear"
        class="full-width left-text guts-p-v-half guts-p-h-1"
        (click)="onAddExperience(experienceType.id)"
        data-dgat="add-experience-menu-2d7"
      >
        <span class="par par--small par--light_a font-semibold">{{
          experienceType.inputSubType
        }}</span>
      </button>
    </li>
  </ul>
</dgx-popover>
